module.exports = __webpack_public_path__ + "img/vouchers20010.52ace059.png";